<template>
  <div
    class="sf-btn sf-btn-bar-item communication-overview-button"
    :class="outerClasses"
    v-bind="$attrs"
    data-testid="sidepane-tab-toggle"
    @click.stop.prevent="handleClick"
  >
    <div
      class="sf-icon communication-overview-button__icon icon"
      :class="iconClasses"
      :data-testid="`sidepane-tab-${type}`"
    >
      <div
        v-if="itemCount > 0"
        class="sf-icon-badge"
        data-testid="sidepane-tab-count"
      >
        {{ itemCount }}
      </div>
    </div>
    <div class="sf-nowrap sf-text">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'CommunicationOverviewButton',
})

type ItemType = 'note' | 'todo' | 'checklist' | 'audits'

interface Props {
  active?: boolean
  disabled?: boolean
  icon: string
  itemCount?: number
  type: ItemType
}

const props = withDefaults(defineProps<Props>(), {
  icon: '',
  itemCount: 0,
})

const emit =
  defineEmits<{
    'item-clicked': [type: ItemType]
  }>()

const outerClasses = computed(() => {
  return {
    'sf-btn-active': props.active,
    'sf-btn-disabled': props.disabled,
  }
})

const iconClasses = computed(() => {
  return {
    [`icon-${props.icon}`]: true,
  }
})

const handleClick = () => {
  emit('item-clicked', props.type)
}
</script>

<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.communication-overview-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
  pointer-events: all;

  &__icon {
    font-size: 16px;
    line-height: 1;
    margin: 0 0 4px;
    display: inline-flex;
    justify-content: center;
  }
}
</style>
